/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Magnified_Image_AltInputs */

const en_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnified Subtitle Preview`)
};

const fr_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previsualisation agrandie des sous-titres`)
};

const de_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergrößerte Untertitelvorschau`)
};

const it_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima dei sottotitoli ingrandita`)
};

const ru_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличенный предварительный просмотр субтитров`)
};

const es_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de subtítulos ampliada`)
};

const zh_cn2_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放大字幕预览`)
};

const ja_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡大字幕プレビュー`)
};

const hi_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बड़ा करके दिखाया गया उपशीर्षक पूर्वावलोकन`)
};

const pt_pt2_video_export_magnified_image_alt = /** @type {(inputs: Video_Export_Magnified_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização ampliada da legenda`)
};

/**
* | output |
* | --- |
* | "Magnified Subtitle Preview" |
*
* @param {Video_Export_Magnified_Image_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_magnified_image_alt = /** @type {((inputs?: Video_Export_Magnified_Image_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Magnified_Image_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_magnified_image_alt(inputs)
	if (locale === "de") return de_video_export_magnified_image_alt(inputs)
	if (locale === "it") return it_video_export_magnified_image_alt(inputs)
	if (locale === "ru") return ru_video_export_magnified_image_alt(inputs)
	if (locale === "es") return es_video_export_magnified_image_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_magnified_image_alt(inputs)
	if (locale === "ja") return ja_video_export_magnified_image_alt(inputs)
	if (locale === "hi") return hi_video_export_magnified_image_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_magnified_image_alt(inputs)
	return en_video_export_magnified_image_alt(inputs)
});